import RegisterPartnerJsSerializer from './-json-api';

export default class RedirectionTokenSerializer extends RegisterPartnerJsSerializer {}
